import type { TenantProfile } from '@order-pilot/shared';
import type { AuthState } from '@/auth/createAuthPortal';
import { createAuthPortal } from '@/auth/createAuthPortal';
import { portalApi } from '@/lib/api';
import { tenantSession } from '@/lib/session';

export type TenantAuthContextValue = AuthState<TenantProfile>;

/** Tenant-admin session (`aud: tenant`) — the root report routes only. Paths below are API endpoints. */
const tenantPortal = createAuthPortal<TenantProfile>({
  name: 'Tenant',
  session: tenantSession,
  client: portalApi,
  loginPath: '/portal/login',
  logoutPath: '/portal/logout',
  queryKeyPrefixes: [['portal']],
});

export const TenantAuthProvider = tenantPortal.Provider;
export const useTenantAuth = tenantPortal.useAuth;
